// sets

export const SET_SUBCONTRACTOR_SEARCH_RESULTS = 'SET_SUBCONTRACTOR_SEARCH_RESULTS';
export const SET_SC_SEARCH_ERROR = 'SET_SC_SEARCH_ERROR';
export const SET_FETCHING_SC_SEARCH = 'SET_FETCHING_SC_SEARCH';
export const SET_TOTAL_AMOUNT_OF_SC_SEARCH = 'SET_TOTAL_AMOUNT_OF_SC_SEARCH';
export const SET_SEARCH_SC_SHOW_MODAL = 'SET_SEARCH_SC_SHOW_MODAL';
export const SET_SC_LIST_ERROR = 'SET_SC_LIST_ERROR';
export const SET_ADD_SC_SHOW_MODAL = 'SET_ADD_SC_SHOW_MODAL';
export const SET_LIST_OF_SC_FROM_PARSED_FILE = 'SET_LIST_OF_SC_FROM_PARSED_FILE';
export const SET_LIST_OF_SC_MANUALLY = 'SET_LIST_OF_SC_MANUALLY';
export const SET_SC_LIST = 'SET_SC_LIST';
export const SET_FETCHING_SC = 'SET_FETCHING_SC';
export const SET_TOTAL_AMOUNT_OF_SC = 'SET_TOTAL_AMOUNT_OF_SC';

export const SET_SC_STATUS = 'SET_SC_STATUS';
export const SET_SC_STATUS_WITH_COUNTS = 'SET_SC_STATUS_WITH_COUNTS';
export const SET_SC_TIER_RATES = 'SET_SC_TIER_RATES';
export const SET_TRADES_FOR_FILTER_LIST = 'SET_TRADES_FOR_FILTER_LIST';

export const SET_SENDING_SC_LIST = 'SET_SENDING_SC_LIST';
export const SET_SENDING_SC_LIST_SUCCESS = 'SET_SENDING_SC_LIST_SUCCESS';
export const SET_SENDING_SC_LIST_ERROR = 'SET_SENDING_SC_LIST_ERROR';
export const SET_COUNT_OF_ZERO = 'SET_COUNT_OF_ZERO';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SET_HC_SELECTION_FOR_ADD_SC_MODAL = 'SET_HC_SELECTION_FOR_ADD_SC_MODAL';
export const SET_DISPLAY_FILE_NAME = 'SET_DISPLAY_FILE_NAME';

export const SET_ADD_SC_HC_LIST_FETCHING = 'SET_ADD_SC_HC_LIST_FETCHING';
export const SET_ADD_SC_HC_LIST_SUCCESS = 'SET_ADD_SC_HC_LIST_SUCCESS';
export const SET_ADD_SC_HC_LIST_ERROR = 'SET_ADD_SC_HC_LIST_ERROR';

export const SET_HC_FORMS_SUCCESS = 'SET_HC_FORMS_SUCCESS';
export const SET_HC_FORMS_ERROR = 'SET_HC_FORMS_ERROR';
export const SET_HC_FORMS_FETCHING = 'SET_HC_FORMS_FETCHING';
export const SET_PAGE_SIZE = 'SET_SC_PAGE_SIZE';
export const RESET_SELECTED_SUBCONTRACTOR = 'RESET_SELECTED_SUBCONTRACTOR';
export const SET_SELECTED_SUBCONTRACTOR = 'SET_SELECTED_SUBCONTRACTOR';
export const SET_ACCEPT_PARTIAL_MATCHING = 'SET_ACCEPT_PARTIAL_MATCHING';
export const HAS_PARTIAL_MATCHING = 'HAS_PARTIAL_MATCHING';
